/* template */
<template><page><base-container :class='["picker-page"]'><cube-basic-picker/><div :class='["picker-divider-wrapper"]'><cube-divider/></div><cube-multi-picker/><div :class='["picker-divider-wrapper"]'><cube-divider/></div><cube-api-picker/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6327d6b4"}'>
.picker-divider-wrapper
  margin 10px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6327d6b4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6327d6b4"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6327d6b4"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker75b705d9%2Findex")),'cube-multi-picker':getComponent(require("./multi-picker.mpx?isComponent&outputPath=components%2Fmulti-picker6cda7fee%2Findex")),'cube-api-picker':getComponent(require("./api-picker.mpx?isComponent&outputPath=components%2Fapi-pickercfc19ca6%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>